var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Download50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4D4D4D",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 23.976562 5.9785156 A 1.50015 1.50015 0 0 0 22.5 7.5 L 22.5 28.878906 L 19.060547 25.439453 A 1.50015 1.50015 0 0 0 17.984375 24.984375 A 1.50015 1.50015 0 0 0 16.939453 27.560547 L 22.939453 33.560547 A 1.50015 1.50015 0 0 0 25.060547 33.560547 L 31.060547 27.560547 A 1.50015 1.50015 0 1 0 28.939453 25.439453 L 25.5 28.878906 L 25.5 7.5 A 1.50015 1.50015 0 0 0 23.976562 5.9785156 z M 11.5 17 C 8.4802259 17 6 19.480226 6 22.5 L 6 36.5 C 6 39.519774 8.4802259 42 11.5 42 L 36.5 42 C 39.519774 42 42 39.519774 42 36.5 L 42 22.5 C 42 19.480226 39.519774 17 36.5 17 L 30.5 17 A 1.50015 1.50015 0 1 0 30.5 20 L 36.5 20 C 37.898226 20 39 21.101774 39 22.5 L 39 36.5 C 39 37.898226 37.898226 39 36.5 39 L 11.5 39 C 10.101774 39 9 37.898226 9 36.5 L 9 22.5 C 9 21.101774 10.101774 20 11.5 20 L 17.5 20 A 1.50015 1.50015 0 1 0 17.5 17 L 11.5 17 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Download50);
export default __webpack_public_path__ + "static/media/icons8-download-50.7158e90f924c38e29cc9228e8ed07077.svg";
export { ForwardRef as ReactComponent };